import coverageScoreWidget from './coverage-score-widget.json';
import loginByCountryMapWidget from './login-by-country-map-widget.json';
import observationPipelineWidget from './observation-pipeline-widget.json';

const en = {
  coverageScoreWidget,
  observationPipelineWidget,
  loginByCountryMapWidget,
};

export default en;
